/* istanbul ignore file */
import { useEffect } from 'react';
export function useClickAway(ref, onClick) {
    useEffect(() => {
        const documentClick = (event) => {
            if (event.target !== ref.current) {
                onClick();
            }
        };
        document.addEventListener('click', documentClick);
        return () => {
            document.removeEventListener('click', documentClick);
        };
    }, [ref, onClick]);
}
//# sourceMappingURL=use-click-away.js.map